const numericNotZero = '1-9';
const numeric = '0-9';
const alpha = 'ac-hjkmnp-rt-yAC-HJKMNP-RT-Y'; // exclude B I L O S Z
const alphanumeric = alpha + numeric;

export const MBI_REGEX = new RegExp(
  `[${numericNotZero}]{1}[${alpha}]{1}[${alphanumeric}]{1}[${numeric}]{1}[${alpha}]{1}[${alphanumeric}]{1}[${numeric}]{1}[${alpha}]{2}[${numeric}]{2}`,
);
